import React from "react";
import { makeStyles, Spinner, Text } from "@fluentui/react-components";
import { useAdminAuth } from "../AdminAuthContext"
import UsersTable from "../ManageCustomers/UsersTable";
const useStyles = makeStyles({
    center: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "60vh",
        flexDirection: "column",
        gap: "12px",
    },
});
function ManageUsers() {
    const { canManageCustomers, checkingManageAccess } = useAdminAuth();

    const styles = useStyles();
    // Loading state
    if (checkingManageAccess) {
        return (
            <div className={styles.center}>
                <Spinner size="large" />
                <Text>Checking access...</Text>
            </div>
        );
    }

    //  Access denied
    if (canManageCustomers) {
        return (
            <div className={styles.center}>
                <Text weight="semibold">
                    You don’t have access to Manage Users ❌
                </Text>
            </div>
        );
    }
    return <UsersTable />;
}

export default React.memo(ManageUsers);
